import { httpService } from '@/api/v1/http.service'
import { type InfiniteQueryOptions } from '@/types/infinite-query'
import { type LabelAndValue } from '@/types/label-and-value'
import { nextPageParamGetter } from '@/utils/next-page-param-getter'
import { parsePaginatedOptions } from '@/utils/parse-paginated'

import { type OptionsParams } from '../types'

export const classesQueryOptions = (
  params: OptionsParams
): InfiniteQueryOptions<LabelAndValue> => ({
  queryKey: ['panelLessonsGroupsOptionsClassesList', params],
  staleTime: 60 * 100,
  queryFn: ({ pageParam }) =>
    httpService.panel
      .panelLessonsGroupsOptionsClassesList({
        tutor_id: params.tutorId,
        teacher_or_co_teacher_id: params.teacherOrCoTeacherId,
        semester_id: params.semester,
        page: pageParam
      })
      .then(parsePaginatedOptions),

  enabled: !!params.semester,
  getNextPageParam: nextPageParamGetter,
  initialPageParam: 1
})
